import {
  format as dateFnsFormat,
  parseISO,
  addDays,
  addMonths,
  addMinutes,
  addSeconds,
  subDays,
  subMonths,
  subMinutes,
  subSeconds,
  subWeeks,
  endOfMonth,
  startOfMonth,
  differenceInMilliseconds,
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from 'date-fns';
import { toast, Slide, Flip } from 'react-toastify';

export const checkInt = function (num) {
  num = parseInt(num);
  if (isNaN(num) || num === '' || num === 0 || num === '0') {
    return 0;
  } else {
    return num;
  }
};
export const checkFloat = function (num) {
  num = parseFloat(num);
  if (isNaN(num) || num === 0.0 || num === '' || num === 0 || num === '0') {
    return 0.0;
  } else {
    num = formatTotal(num);
    num = parseFloat(num);
    if (isNaN(num) || num === 0.0 || num === '' || num === 0 || num === '0') {
      return 0.0;
    } else {
      return num;
    }
  }
};
export const checkEmpty = function (mixedVar) {
  var key;
  if (typeof mixedVar == 'object') {
    for (key in mixedVar) {
      if (Object.hasOwnProperty.bind(mixedVar)(key)) {
        return false;
      }
    }
    return true;
  } else {
    var undef;

    var i;
    var len;
    var emptyValues = [
      undef,
      null,
      'null',
      false,
      0,
      '',
      '0',
      '0.00',
      '0.0',
      'empty',
      undefined,
      'undefined',
    ];
    if (typeof mixedVar == 'string') {
      mixedVar = mixedVar.trim();
    }

    for (i = 0, len = emptyValues.length; i < len; i++) {
      if (mixedVar === emptyValues[i]) {
        return true;
      }
    }
  }
  return false;
};

export const findIndex = function (mixedVar, key, value) {
  let index = '';
  // if (typeof mixedVar == 'object')
  // {
  // 	var f;
  // 	var filteredElements = mixedVar.filter(function(item, index) { f = index; return item[key] == value; });
  // 	if (filteredElements.length) {
  // 	index = f;
  // }
  // }else if (typeof mixedVar == 'array')
  // {

  // }

  index = mixedVar.findIndex(({ key }) => key === value);
  return index;
};

export const formatTotal = function (num) {
  return number_format(Math.round(num * 100) / 100, 2, '.', '');
};
export const formatTotalCurrency = function (num) {
  return '£' + number_format(Math.round(num * 100) / 100, 2, '.', '');
};

export const number_format = function (number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep == 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point == 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  // Fix for IE checkFloat(0.55).toFixed(0) = 0
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

export const cleanString = function (string) {
  string = string.trim();
  string = string.replace(/ /g, '-');
  // eslint-disable-next-line
  string = string.replace(/[^A-Za-z0-9\-]/g, '');
  string = string.replace(/-+/g, '-');
  return string;
};

export const mergeObj = (finalObj, newObj) => {
  var finalObjFirstInsertKey = 0;
  if (!checkEmpty(finalObj)) {
    finalObjFirstInsertKey = finalObj.length;
  }
  if (!checkEmpty(newObj)) {
    for (let i in newObj) {
      finalObj[finalObjFirstInsertKey] = newObj[i];
    }
  }
  return finalObj;
};

export const validateMobileNumber = (number) => {
  number = number.trim();
  number = checkInt(number);
  number = number + '';
  if (number.length === 10) {
    return true;
  } else {
    return false;
  }
};

export const validateEmailAddress = (email) => {
  return email;
};

const FMT = 'yyyy-MM-dd HH:mm:ss';
const p = (date) => (typeof date === 'string' ? parseISO(date) : date);

export const carbon = {
  now: function () {
    return dateFnsFormat(new Date(), FMT);
  },
  parse: function (date) {
    return dateFnsFormat(p(date), FMT);
  },
  yesterday: function () {
    return dateFnsFormat(subDays(new Date(), 1), FMT);
  },
  fromDay: function (_req, dayCount) {
    return dateFnsFormat(subDays(new Date(), dayCount), FMT);
  },
  tomorrow: function () {
    return dateFnsFormat(addDays(new Date(), 1), FMT);
  },
  format: function (date, frmt) {
    return dateFnsFormat(p(date), frmt);
  },
  strtotime: function (_req, date) {
    return p(date).getTime() / 1000;
  },
  isGreater: function (date1, date2) {
    return p(date1) > p(date2);
  },
  isGreaterOrEqual: function (date1, date2) {
    return p(date1) >= p(date2);
  },
  isLessOrEqual: function (date1, date2) {
    return p(date1) <= p(date2);
  },
  addDay: function (date, day) {
    return dateFnsFormat(addDays(p(date), day), FMT);
  },
  addMonth: function (date, months) {
    return dateFnsFormat(addMonths(p(date), months), FMT);
  },
  addDayFormat: function (date, day, frmt) {
    return dateFnsFormat(addDays(p(date), day), frmt);
  },
  subDay: function (date, day) {
    return dateFnsFormat(subDays(p(date), day), FMT);
  },
  addMinutes: function (date, minutes) {
    return dateFnsFormat(addMinutes(p(date), minutes), FMT);
  },
  subMinutes: function (date, minutes) {
    return dateFnsFormat(subMinutes(p(date), minutes), FMT);
  },
  subSeconds: function (date, seconds) {
    return dateFnsFormat(subSeconds(p(date), seconds), FMT);
  },
  diff: function (date1, date2, unit) {
    const d1 = p(date1);
    const d2 = p(date2);
    if (unit === 'days') return differenceInDays(d1, d2);
    if (unit === 'months') return differenceInMonths(d1, d2);
    if (unit === 'years') return differenceInYears(d1, d2);
    return differenceInMilliseconds(d1, d2);
  },
  endofMonth: (date, frmt) => dateFnsFormat(endOfMonth(p(date)), frmt),
  firstOfMonth: (date, frmt) => dateFnsFormat(startOfMonth(p(date)), frmt),
  subMonths: function (date, months) {
    return dateFnsFormat(subMonths(p(date), months), FMT);
  },
  subWeek: function (date, week) {
    return dateFnsFormat(subWeeks(p(date), week), FMT);
  },
};

export const setStotage = (key, value) => {
  localStorage.setItem(key, value);
};
export const setStorageJson = (key, value) => {
  try {
    value = JSON.stringify(value);
    localStorage.setItem(key, value);
  } catch (err) {
    //console.log("Couldn't save data: " + err);
  }
};
export const getStorage = (key) => {
  return localStorage.getItem(key);
};
export const getStorageJson = (key, obj) => {
  if (obj === undefined) {
    obj = false;
  }
  var value = '';
  try {
    value = localStorage.getItem(key);
    value = JSON.parse(value);
    if (checkEmpty(value)) {
      if (obj) {
        value = {};
      } else {
        value = [];
      }
    }
  } catch (err) {
    if (obj) {
      value = {};
    } else {
      value = [];
    }
  }
  return value;
};
export const removeStorage = (key) => {
  localStorage.removeItem(key);
};
export const clearStorage = () => {
  localStorage.clear();
};

export const setAuthStorage = (resp) => {
  let config = {};
  //config.userdata = resp?.user_config;
  //console.log()
  //setStorageJson('config', config);
  setStotage('uuid', resp?.userid);
  setStotage('token', resp?.token);
  //setStotage('jjpi', resp?.jjpi);
  //setStotage('staffid', resp?.userdata?.redoq_csd_staff_Id);
};

export const setBasicdataStorage = (resp) => {
  let config = getStorageJson('config');
  config.basicdata = resp;
  setStorageJson('config', config);
};
export const preapre_dropdown_options = (
  object,
  keyOfValue,
  keyOfLabel,
  defaultValue = 0,
  defaultLabel = 'All'
) => {
  let finalResponse = [
    {
      value: defaultValue,
      label: defaultLabel,
    },
  ];
  for (let i in object) {
    finalResponse.push({
      value: object[i][keyOfValue],
      label: object[i][keyOfLabel],
    });
  }
  return finalResponse;
};
export const externalLink = (url) => {
  if (url) {
    window.open('https://' + url, '_blank');
  }
};

export const successnotify = (apiMessage) =>
  toast.success(`${apiMessage}`, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });

// you should always add this in your component and import react-toastify
{
  /* <ToastContainer
	position="top-right"
	autoClose={2000}
	hideProgressBar={false}
	newestOnTop={false}
	closeOnClick
	rtl={false}
	pauseOnFocusLoss
	draggable
	pauseOnHover={false}
	theme="light"
/> */
}

export const errorNotify = (apiMessage) =>
  toast.error(`${apiMessage}`, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });

export const Toastslideerror = (mes) =>
  toast.error(<p className="text-white tx-16 mb-0 ">{mes}</p>, {
    position: 'top-right',
    hideProgressBar: true,
    transition: Slide,
    autoClose: 1500,
    theme: 'colored',
  });

export const Toastslidesucc = (mes) =>
  toast.success(<p className="text-white tx-16 mb-0 ">{mes}</p>, {
    position: 'top-right',
    hideProgressBar: true,
    transition: Slide,
    autoClose: 1500,
    theme: 'colored',
  });

export const productsName = {
  TWF_HOUR_ACCIDENT_INSURANCE: '24 Hour Accident Insurance',
  // "ACCIDENT_INSURANCE": "Accident Insurance",
  AFFORDABLE_CHOICE: 'Affordable Choice',
  CANCER_CARE_PLUS: 'Cancer Care Plus',
  // "CANCER_FIRST_OCCURRENCE": "Cancer First Occurrence",
  CANCER_HEART_ATTACK_AND_STROKE: 'Cancer Heart Attack and Stroke',
  CRITICAL_PROTECTION_AND_RECOVERY: 'Critical Protection and Recovery',
  FIRST_CHOICE_BLUE_RIBBON_SERIES: 'First Choice Blue Ribbon Series',
  HOME_HEALTH_CARE_SELECT: 'Home Health Care Select',
  OMNIFLEX_SHORT_TERM_CARE: 'OmniFlex Short-Term Care',
  OUT_OF_POCKET_PROTECTION_PLAN: 'Out-of-Pocket Protection Plan',
  SECURE_ADVANTAGE_FINAL_EXPENSE: 'Secure Advantage - (Final Expense)',
  DENTAL_VISION_HEARING_SELECT: 'Dental, Vision & Hearing Select',
  DISCOUNT_DENTAL: 'Discount dental',
  DENTAL_NCD: 'Dental NCD',
  LIFE_INSURANCE: 'Life Insurance',
};
